import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { LocalizationContext } from 'contexts/LocalizationContext';

/** טקסטים ל־TimePicker / DatePicker — חלקי; השאר נופל לברירת MUI */
const PICKERS_LOCALE_TEXT_HE = {
  okButtonLabel: 'אישור',
  cancelButtonLabel: 'ביטול',
  clearButtonLabel: 'ניקוי',
  todayButtonLabel: 'היום',
};

/**
 * עוטף את האפליקציה ב־LocalizationProvider של MUI X עם תרגום לעברית לכפתורי דיאלוג (למשל «אישור» במקום OK).
 * חייב להיות בתוך LocalizationLanguageProvider.
 */
export default function DatePickersLocaleProvider({ children }: { children: React.ReactNode }) {
  const { currentLanguage } = React.useContext(LocalizationContext);

  const localeText = currentLanguage === 'he' ? PICKERS_LOCALE_TEXT_HE : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} localeText={localeText}>
      {children}
    </LocalizationProvider>
  );
}
